import { styled } from "@givenwell/stitches";

export const Fieldset = styled("fieldset", {});
